const permissions = {
  header: 'Roles & Permissions',
  notice: 'Changes will affect users with matching roles across all company sites.',
  toast: {
    delete: 'Role deleted assigned successfully',
    error: 'Something was wrond',
  },
  actions: {
    save: {
      button: 'Save Changes',
      confirmModal: {
        title: 'Confirmation',
        content: 'Are you sure would you like to save the changes?',
        confirm: 'Confirm',
      },
      error: 'An error occurred updating the permissions.',
      success: 'Permissions successfully updated!',
    },
    search: {
      placeholder: 'Search...',
    },

    delete: {
      deleteBtn: 'Delete',
    },
    history: {
      historyBtn: 'History',
    },
  },
  roleCard: {
    actions: {
      default: {
        label: 'Default',
        title: 'Restore Default Permissions for "{{ name }}" Role',
        text: "By proceeding, you will revert to the default role permissions, resulting in the loss of all the adjustments you've made.",
        confirm: 'Confirm',
        success: 'Role default permissions restored successfully.',
        failure: "Couldn't restore role permissions due to unexpected error.",
      },
      delete: {
        title: 'Delete Roles',
        deletionEnabled: 'You are about to delete 1 role',
        deletionDisabled: 'Cannot delete role with {{ count }} connected users. Please remove users before deleting',
      },
    },
    select: {
      all: 'Set all permissions',
      none: 'Unset all permissions',
    },
    count: '{{ count }} users',
  },
  addRoleCard: {
    title: 'Add +',
    createMode: {
      label: 'Name:',
    },
  },
  scope: {
    'Holidays': 'Holidays',
    'MissionControl': 'MissionControl',
    'Timeline': 'Timeline',
    'OnlineDrivers': 'Online Drivers',
    'Reservations': 'Booking',
    'LiveMap': 'Live Map',
    'Settings': 'Settings',
    'SettingsTemplates': 'Settings Templates',
    'Vehicles': 'Vehicles',
    'Trips': 'Trips',
    'Suppliers': 'Suppliers',
    'Shuttles': 'Shuttles',
    'Shifts': 'Shifts',
    'Services': 'Services',
    'Roles and Permissions': 'Roles and Permissions',
    'Reports': 'Reports',
    'Rates': 'Rates',
    'Profiles': 'Profiles',
    'Passengers': 'Passengers',
    'Parent': 'Parent',
    'Users': 'Users',
    'Locations': 'Locations',
    'Integrations': 'Integrations',
    'Fares': 'Fares',
    'ExtraServices': 'Extra Services',
    'Drivers': 'Drivers',
    'DriverShifts': 'Driver Shifts',
    'DriverShiftsTemplates': 'Driver Shifts Templates',
    'DataUpload': 'Import',
    'Export': 'Export',
    'CustomRules': 'Custom Rules',
    'BlacklistCards': 'Blacklist Cards',
    'Automations': 'Automations',
    'Attributes': 'Attributes',
    'Areas': 'Zones',
    'ApiKeys': 'API Keys',
    'Caregivers': 'Caregivers',
  },
  sitesViewError: 'Switch to a single site view in order to access this page',
};

export default permissions;
